export function toOdiItem({ branch, commit, version }) {
	return {
		note: commit || version,
		text: branch || '<unknown>',
		value: version,
	};
}
